import { Card } from '@material-ui/core';
import styled from 'styled-components';
import { diffuseGlass } from 'styles/mixins';

export const MobileStyledHeader = styled(Card)`
    position: absolute;
    top: ${({ theme }) => theme.spacing(1)}px;
    left: 50%;
    z-index: 200;
    width: max-content;
    transform: translateX(-50%);
    ${diffuseGlass}
`;

export const StyledHeader = styled(Card)`
    position: absolute;
    top: ${({ theme }) => theme.spacing(2)}px;
    left: 50%;
    z-index: 200;
    transform: translateX(-50%);
    ${diffuseGlass}
`;
